export default "__VITE_ASSET__41204b34__"